// extracted by mini-css-extract-plugin
var _1 = "VideoDetails-module_details__3rsHO";
var _2 = "VideoDetails-module_divider__gvumM";
var _3 = "VideoDetails-module_link__MD2Ax";
var _4 = "VideoDetails-module_videoTitle__D0Fb3";
var _5 = "VideoDetails-module_wrapper__s7VI_";
export { _1 as "details", _2 as "divider", _3 as "link", _4 as "videoTitle", _5 as "wrapper" }
export default { "details": _1, "divider": _2, "link": _3, "videoTitle": _4, "wrapper": _5 }
